import { LOGIN_METHOD } from "../../../../constants";
import LineLogin from "../sso/line-login";
import { ENGAGE_GET_CREDIT_SESSION } from "../../../../constants";

type Params = {
  defaultLoginMethod: string;
  subCampaignId?: string;
  qrscanlogId?: string;
  channelSessionId?: string;
  engageGetCreditSession?: string;
  merchantReference?: string;
  isEGC: boolean;
  handleSubmit: () => void;
};

export const lineSsoSubmit = ({
  defaultLoginMethod,
  subCampaignId,
  qrscanlogId,
  channelSessionId,
  engageGetCreditSession,
  merchantReference,
  isEGC,
  handleSubmit,
}: Params) => {
  if (defaultLoginMethod !== LOGIN_METHOD.LINE_SSO) return;

  const storedUserID = localStorage.getItem("userID");
  if (storedUserID && storedUserID !== "undefined" && storedUserID !== "null" && storedUserID !== "") {
    handleSubmit();
    return;
  }

  // clear previous session
  localStorage.removeItem("userID");
  localStorage.removeItem("profileName");
  localStorage.removeItem("LINE_AUTH_CALLBACK");

  // Save campaign context so it persists after OAuth redirect
  localStorage.setItem("subcampaign_id", subCampaignId || "");
  localStorage.setItem("qrscanlog_id", qrscanlogId || "");
  localStorage.setItem("channel_session_id", channelSessionId || "");
  localStorage.setItem(ENGAGE_GET_CREDIT_SESSION, engageGetCreditSession || "");
  localStorage.setItem("merchant_reference", merchantReference || "");

  const lineLogin = new LineLogin(defaultLoginMethod);
  const authUrl = lineLogin.auth();
  window.location.href = authUrl;
};
